import { useContext, useMemo } from "react";
import BreakpointContext from "../../contexts/BreakpointContext";
import isBreakpointValueFulfillingBreakpointRange from "../../utils/isBreakpointValueFulfillingBreakpointRange";
var useBreakpoint = function useBreakpoint(minBreakpoint, maxBreakpoint) {
  var currentBreakpoint = useContext(BreakpointContext);
  var state = useMemo(function () {
    return isBreakpointValueFulfillingBreakpointRange(currentBreakpoint, minBreakpoint, maxBreakpoint);
  }, [currentBreakpoint, minBreakpoint, maxBreakpoint]);
  return state;
};
export default useBreakpoint;